(function () {
    'use strict';

    const tabContainers = document.querySelectorAll('.tabcordion');
    const isProductPage = document.body.classList.contains('single-product');

    if (tabContainers.length === 0) {
        return;
    }

    tabContainers.forEach((tabContainer) => {
        const panels = tabContainer.querySelectorAll('.tabcordion__panel');
        const tabButtons = tabContainer.querySelectorAll('.tabcordion__tab');

        if (panels.length === 0) {
            return;
        }

        panels.forEach((panel, index) => {

            // Always allow the first panel to be active
            if(!isProductPage) {
                if (index === 0 && window.innerWidth > 1200) {
                    panel.classList.add('tabcordion__panel--active');
                    panel.setAttribute('aria-selected', 'true');
                } else {
                    panel.classList.remove('tabcordion__panel--active');
                    panel.setAttribute('aria-selected', 'false');
                }
            }

            // Add click event listener to each accordion panel
            panel.addEventListener('click', () => {
                if (!isProductPage || window.innerWidth <= 1200 || (isProductPage && window.innerWidth > 1200)) {
                    const panelId = panel.id;
                    const parts = panelId.split('-');
                    const newPanelId = parts[parts.length - 1];

                    tabButtons.forEach((button) => {
                        const buttonId = button.id;
                        const parts = buttonId.split('-');
                        const newButtonId = parts[parts.length - 1];

                        if (newPanelId === newButtonId) {
                            button.classList.add('tabcordion__tab--active');
                            button.setAttribute('aria-selected', 'true');
                        } else {
                            button.classList.remove('tabcordion__tab--active');
                            button.setAttribute('aria-selected', 'false');
                        }
                    });

                    const isActive = panel.classList.contains('tabcordion__panel--active');

                    // Toggle the clicked accordion panel
                    if (!isActive) {
                        panels.forEach((panel) => {
                            panel.classList.remove('tabcordion__panel--active');
                            panel.setAttribute('aria-selected', 'false');
                        });

                        panel.classList.add('tabcordion__panel--active');
                        panel.setAttribute('aria-selected', 'true');
                    } else {
                        panel.classList.remove('tabcordion__panel--active');
                        panel.setAttribute('aria-selected', 'false');

                        tabButtons.forEach((button) => {
                            button.classList.remove('tabcordion__tab--active');
                            button.setAttribute('aria-selected', 'false');
                        });
                    }
                }
            });
        });

        if (tabButtons.length > 0) {
            tabButtons.forEach((button, index) => {
                if (!isProductPage || window.innerWidth <= 1200) {
                    if (index === 0 && window.innerWidth > 1200) {
                        button.classList.add('tabcordion__tab--active');
                        button.setAttribute('aria-selected', 'true');
                    } else {
                        button.classList.remove('tabcordion__tab--active');
                        button.setAttribute('aria-selected', 'false');
                    }
                }

                button.addEventListener('click', () => {
                    if (!isProductPage || window.innerWidth <= 1200 || (isProductPage && window.innerWidth > 1200)) {
                        const isActive = button.classList.contains('tabcordion__tab--active');

                        const panelId = button.getAttribute('aria-controls');
                        const panel = document.getElementById(panelId);

                        if (!isActive) {
                            tabButtons.forEach((tabButton) => {
                                tabButton.classList.remove('tabcordion__tab--active');
                                tabButton.setAttribute('aria-selected', 'false');
                            });

                            panels.forEach((panel) => {
                                panel.classList.remove('tabcordion__panel--active');
                                panel.setAttribute('aria-hidden', 'true');
                            });

                            button.classList.add('tabcordion__tab--active');
                            button.setAttribute('aria-selected', 'true');
                            panel.classList.add('tabcordion__panel--active');
                            panel.setAttribute('aria-hidden', 'false');
                        }
                    }
                });
            });
        }

        tabContainer.panels = panels;
    });

    function handleResize() {
        tabContainers.forEach((tabContainer) => {
            if (!isProductPage && window.innerWidth > 1200) {
                if (tabContainer.panels) {
                    let hasActivePanel = false;

                    tabContainer.panels.forEach((panel) => {
                        if (panel.classList.contains('tabcordion__panel--active')) {
                            hasActivePanel = true;
                        }
                    });

                    if (!hasActivePanel) {
                        const tabButtons = tabContainer.querySelectorAll('.tabcordion__tab');

                        if (tabButtons.length > 0) {
                            tabButtons[0].classList.add('tabcordion__tab--active');
                            tabContainer.panels[0].classList.add('tabcordion__panel--active');
                        }
                    }
                }
            }
        });
    }

    function debounce(func, delay) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }

    const debouncedResize = debounce(handleResize, 250);
    window.addEventListener('resize', debouncedResize);

    const hasTabs = function(container) {
        return container.classList.contains('has-tabs');
    };

    const modeSwitcher = function(tabContainer, containerWidth) {
        const tabs = tabContainer.querySelectorAll('.tabcordion__tab');
        const container = tabs[0] ? tabs[0].closest('.tabcordion') : null;

        if (container && !isProductPage) {
            if (window.innerWidth <= containerWidth && hasTabs(container)) {
                container.classList.remove('has-tabs');
            } else if (window.innerWidth > containerWidth && !hasTabs(container)) {
                container.classList.add('has-tabs');
            }
        }
    };

    if (tabContainers.length > 0) {
        tabContainers.forEach((tabContainer) => {
            modeSwitcher(tabContainer, 1200);

            window.addEventListener('resize', () => {
                modeSwitcher(tabContainer, 1200);
            });
        });
    }
})();